/**
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module find-and-replace/findandreplaceui
 */
import { Plugin } from 'ckeditor5/src/core';
import { createDropdown } from 'ckeditor5/src/ui';
import BlocksView from "./ui/blocks-view";

export default class BlocksUi extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'BlocksUi';
    }
    /**
     * @inheritDoc
     */
    constructor(editor) {
        super(editor);
        this.formView = null;
    }
    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        // Register the toolbar dropdown component.
        editor.ui.componentFactory.add('blocks', locale => {
            const dropdown = createDropdown(locale);
            dropdown.once('change:isOpen', () => {
                this.formView = new BlocksView(editor);
                dropdown.panelView.children.add(this.formView);
            });
            this._setupDropdownButton(dropdown);
            return dropdown;
        });
    }
    _setupDropdownButton(dropdown) {
        const editor = this.editor;
        const t = editor.locale.t;
        const insertAnnouncementBox = this.editor.commands.get('insertAnnouncementBox');
        const imageAndTextBox = this.editor.commands.get('imageAndTextBox');
        const insertImagesAndTextBox = this.editor.commands.get('insertImagesAndTextBox');
        const insertTextBox = this.editor.commands.get('insertTextBox');
        const insertMovieAndTextBox = this.editor.commands.get('insertMovieAndTextBox');
        const imageAndQuoteBox = this.editor.commands.get('imageAndQuoteBox');
        const insertImagesBox = this.editor.commands.get('insertImagesBox');
        const commands = [insertAnnouncementBox, imageAndTextBox, insertImagesAndTextBox, insertTextBox,
            insertMovieAndTextBox, imageAndQuoteBox, insertImagesBox];

        dropdown.buttonView.set({
            withText: true,
            label: t('Blocks'),
            // keystroke: 'CTRL+F',
            tooltip: true,
            class: 'ck-custom-toolbar-button'
        });
        dropdown.bind( 'isEnabled' ).toMany( commands, 'isEnabled', ( ...areEnabled ) => {
            return areEnabled.some( isEnabled => isEnabled );
        } );
    }
}


